module.exports = {
  domain: {
     api: process.env.REACT_APP_API_DOMAIN  || 'https://api-staging.a-smartlearning.com', //live platform
    // api: process.env.REACT_APP_API_DOMAIN || 'https://asls-test.herokuapp.com', //test

    // api: process.env.REACT_APP_API_DOMAIN || 'http://localhost:9000',
    mediaApi: process.env.REACT_APP_MEDIA_API_DOMAIN || 'https://media.zenquiz.net'
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/env.js
 **/